export const productDataBottoms = [
    {
      id: "1Faldasemicuero",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_964087-MLA51472730797_092022-W.webp',
      name: "Falda semi cuero",
      price: "3600",
      description: "bottoms",
      IsSale: "Sale",
      signo: "$",
      pricebefore: "3800",
      colorbc: "pink",
      color: "black",
      tallas: [ 1,2,3 ],
      quantity: 1,
    },
    
    {
      id: "2Faldadejeanconbolsillos",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_739178-MLA52161304862_102022-W.webp",
      name: "Falda de jean con bolsillos",
      price: "6000",
      description: "bottoms",
      color: "jean",      
      IsTalla: "Talla",
      IsSale: "Nuevo",      
      colorbc: "pink",
      tallas: [ 2,3,4],
      quantity: 1,
    },
    {
      id: "3Faldaconcortelateral",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_825458-MLA52700978401_122022-W.webp",
      name: "Falda con corte lateral",
      price: "5000",
      description: "bottoms",
      color: "black",       
      IsTalla: "Talla",
      IsSale: "Nuevo",      
      colorbc: "pink",
      tallas: [ 1,2 ],
      quantity: 1,
    },
    {
      id: "4Faldadejeans",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_746406-MLA44082684409_112020-W.webp",
      name: "Falda de jeans",
      price: "6000",
      description: "bottoms",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 4,5 ],
      quantity: 1,
    },
    {
      id: "5Faldashortdejeans",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_858868-MLA52858728361_122022-W.webp",
      name: "Falda short de jeans",
      price: "6500",
      description: "bottoms",
      color: "jean",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4 ],
      quantity: 1,
    },
    {
      id: "6Shortjeansengomado",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_712378-MLA52863296277_122022-W.webp",
      name: "Short jeans engomado",
      price: "6000",
      description: "bottoms",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2, 3, 4 ],
      quantity: 1,
    },
    {
      id: "7Shortsemicuero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_642479-MLA52270227991_112022-W.webp",
      name: "Short semi cuero",
      price: "7000",
      description: "bottoms",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2 ],
      quantity: 1,
    },
    {
      id: "8Shortestampadodelino",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_742624-MLA53456135135_012023-W.webp",
      name: "Short estampado de lino",
      price: "4000",
      description: "bottoms",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "9Bermudalarga",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_642170-MLA53338923005_012023-W.webp",
      name: "Bermuda larga",
      price: "4500",
      description: "bottoms",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "10Shortdefibrana",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_894151-MLA52579992758_112022-W.webp",
      name: "Short de fibrana",
      price: "5000",
      description: "bottoms",
      color: "brown",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "11Pantalonbaggy",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_899571-MLA53235100733_012023-W.webp",
      name: "Pantalon baggy",
      price: "6500",
      description: "bottoms",
      color: "brown",      
      IsTalla: "Talla",
      tallas: [ 3,4,5 ],
      quantity: 1,
    },
    {
      id: "12Pantaloncuerinatiroalto",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_783894-MLA47075044400_082021-W.webp",
      name: "Pantalon cuerina tiro alto",
      price: "7000",
      description: "bottoms",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2 ],
      quantity: 1,
    },
    {
      id: "13Joggercasual",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_695085-MLA47122756681_082021-W.webp",
      name: "Jogger casual",
      price: "4700",
      description: "bottoms",
      color: "pink",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4 ],
      quantity: 1,
    },
    {
      id: "14Pantalonpalazzo",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_649842-MLA53513364377_012023-W.webp",
      name: "Pantalon palazzo",
      price: "7500",
      description: "bottoms",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "15Jeanconroturas",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_822590-MLA44271105704_122020-W.webp",
      name: "Jean con roturas",
      price: "7500",
      description: "bottoms",
      color: "jean",      
      IsTalla: "Talla",
      tallas: [ 1,2,3],
      quantity: 1,
    },
    {
      id: "16Pantalonpalazzotiroalto",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_773020-MLA51787615178_102022-W.webp",
      name: "Pantalon palazzo tiro alto",
      price: "7000",
      description: "bottoms",
      color: "orange",      
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
  ];